import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { required } from "ra-core";
import { DateTimeInput } from "@/components/admin";
import type { Sale } from "../types";

import { contactOptionText } from "../misc/ContactOption";
import { useConfigurationContext } from "../root/ConfigurationContext";

export const TaskFormContent = ({
  selectContact,
}: {
  selectContact?: boolean;
}) => {
  const { taskTypes } = useConfigurationContext();
  return (
    <div className="flex flex-col gap-4">
      <TextInput
        autoFocus
        source="text"
        validate={required()}
        multiline
        className="m-0"
        helperText={false}
      />
      {selectContact && (
        <ReferenceInput source="contact_id" reference="contacts">
          <AutocompleteInput
            label="resources.tasks.fields.contact_id"
            optionText={contactOptionText}
            helperText={false}
            validate={required()}
            modal
          />
        </ReferenceInput>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <DateTimeInput
          source="due_date"
          helperText={false}
          validate={required()}
        />
        <SelectInput
          source="type"
          validate={required()}
          choices={taskTypes}
          optionText="label"
          optionValue="value"
          defaultValue="none"
          helperText={false}
        />
      </div>
      <ReferenceInput
        source="sales_id"
        reference="sales"
        filter={{ "disabled@neq": true }}
      >
        <SelectInput
          label="Responsabile"
          parse={(value) =>
            value === "" || value == null ? null : Number(value)
          }
          optionText={(sale: Sale) => `${sale.first_name} ${sale.last_name}`}
          validate={required()}
          helperText={false}
        />
      </ReferenceInput>
      <TextInput
        source="blocked_reason"
        label="In attesa di…"
        helperText="Facoltativo: cosa impedisce di proseguire? Svuota il campo quando puoi ripartire."
      />
    </div>
  );
};
